package ro.horatiu_udrea.resursedeblocat

import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import androidx.lifecycle.ViewModel

class TrackingViewModel(private val userId: String) : ViewModel() {
    var trackings by mutableStateOf<List<MonthlyTracking>>(emptyList())
        private set

    var isLoading by mutableStateOf(false)
        private set

    var errorMessage by mutableStateOf<String?>(null)
        private set

    fun loadTrackings() {
        isLoading = true
        getTrackings(userId, { list ->
            trackings = list.sortedByDescending { it.year * 100 + it.month }
            isLoading = false
        }, { error ->
            errorMessage = error
            isLoading = false
        })
    }

    fun canTrackLastMonth(): Boolean {
        val current = getCurrentMonthYear()
        val lastMonth = if (current.month == 1) 12 else current.month - 1
        val lastYear = if (current.month == 1) current.year - 1 else current.year
        
        return trackings.none { it.month == lastMonth && it.year == lastYear }
    }

    fun getLastMonthYear(): MonthYear {
        val current = getCurrentMonthYear()
        val lastMonth = if (current.month == 1) 12 else current.month - 1
        val lastYear = if (current.month == 1) current.year - 1 else current.year
        return MonthYear(lastMonth, lastYear)
    }
}
